import { render, staticRenderFns } from "./simpleTaskView.vue?vue&type=template&id=436b6e14&scoped=true&"
import script from "./simpleTaskView.vue?vue&type=script&lang=js&"
export * from "./simpleTaskView.vue?vue&type=script&lang=js&"
import style0 from "./simpleTaskView.vue?vue&type=style&index=0&id=436b6e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b6e14",
  null
  
)

export default component.exports